import React from "react";
import "./App.css";
import MainCardContainer from "./component/Container";
import { observer } from "mobx-react-lite";
import Preloader from "./component/Preloader";
import { useCustDiagStore } from "./contexts/RootStoreProvider";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Resolution from "./component/Resolution";

function App() {
  const custDiagStore = useCustDiagStore();

  return (
    <>
      <BrowserRouter>
        {custDiagStore.isLoading ? <Preloader /> : ""}
        <Routes>
          <Route path="/" element={<MainCardContainer />} />
          <Route path="/resolution/:id" element={<Resolution />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default observer(App);
